import { AfterViewInit, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { icons } from '../../sharedcomp/constans/icons.constans';
import { AuthService, CustomerService, UserService } from '../../_services';
import { Observable, Subject, of } from 'rxjs';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { User, UserList } from 'src/app/_models';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { DataService } from 'src/app/_helpers';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SectionNames, TabItems } from './utils/layout.constans';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: [
    './layout.component.css',
    '../../../assets/css/new-component-view.css',
    '../../../assets/css/new-badges-chips-theme.css'
  ],
  providers: [Ng4LoadingSpinnerService]
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  icons: typeof icons;
  activeTab: string | null = null;
  tabOffsetLeft: number;
  tabOffsetWidth: number;
  isProfileAvailable: boolean = false;

  items: string[] = [];
  customerPublicId: string;
  getCustomerUserList$: Observable<UserList[]>;
  activeUsers: number;

  tabNameByState: string;
  batchSectionMessage: {title: string; description: string;} = { title: '', description: '' };
  routeState: {title: string; description: string;} = { title: '', description: '' };

  private destroy$ = new Subject<void>();

  constructor(
    private auth: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.icons = icons;
    this.setBatchMessage();
  }

  ngOnInit() {
    const params: string = this.activatedRoute.snapshot.queryParams.tabName;
    this.tabNameByState = params;
    this.batchSectionMessage = this.tabNameByState === SectionNames.BATCH ? this.routeState : null;
    this.checkPermission();
    this.loadTabs();
    this.loadSpinnerStatus();
  }

  setBatchMessage() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras.state) {
      const {title, description} = navigation.extras.state;
      this.routeState = {title, description};
    }
  }

  loadSpinnerStatus() {
    this.dataService.loadSpinnerSubject$
      .pipe(
        tap(status => {
          if (status) {
            this.spinnerService.show();
          } else {
            this.spinnerService.hide();
          }
        })
      )
      .subscribe();
  }

  checkPermission() {
    const isDesignVersionV2 = localStorage.getItem('designVersion') === 'V2';
    if (!isDesignVersionV2) {
      this.router.navigate(['/']);
    }

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;

    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('isadmin');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ngAfterViewInit() { }

  async loadTabs() {
    await this.auth.isKashioGrantsAvailable();
    this.items = this.buildTabItems(TabItems);
    const selectedTabName = this.tabNameByState !== null && this.items.includes(this.tabNameByState) ? this.tabNameByState : this.items[0];
    this.setActiveTab(selectedTabName);
  }

  buildTabItems(tabItems: {
    key: string;
    grants: string[];
  }[]): string[] {
    let items = [];
    
    tabItems.forEach(item => {
      if (this.checkGrantsCondition(item.grants[0], item.grants[1])) {
        items.push(item.key);
      }
    });

    if (items.length <= 1) {
      items.push('Contraseña');
    } else {
      items.splice(1, 0, 'Contraseña');
    }

    return items;
  }

  checkGrantsCondition(grant1: string, grant2: string): boolean {
    return this.auth.checkGrants(grant1, grant2);
  }

  goToSelectedTab(tabName: string) {
    this.setActiveTab(tabName);
    const tabNameQuery = {tabName};
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: tabNameQuery,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      replaceUrl: true
    });
  }

  setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
